import { takeLatest, put, call, takeEvery } from "redux-saga/effects";
import { toast } from "react-toastify";
import {
  LK_RECIPIENT_DETAILS,
  LK_RECIPIENT_DETAILS_SUCCESS,
  LK_RECIPIENT_DETAILS_FAIL,
  EDIT_LK_RECIPIENT,
  EDIT_LK_RECIPIENT_SUCCESS,
  EDIT_LK_RECIPIENT_FAIL,
  LK_RECIPIENT_HISTORY,
  LK_RECIPIENT_HISTORY_SUCCESS,
  LK_RECIPIENT_HISTORY_FAIL,
} from "./actionTypes";

import {
  LkRecipientDetails,
  editLkRecipient,
  lkRecipientHistory,
} from "../../_helper/Lk_Recipient";
import { ShowSucess, ShowError } from "../../_helper/helper";

function* getLKRecipientHistory({ payload }) {
  try {
    const response = yield call(lkRecipientHistory, payload);
    yield put({ type: LK_RECIPIENT_HISTORY_SUCCESS, response });
  } catch (error) {
    yield put({
      type: LK_RECIPIENT_HISTORY_FAIL,
      message: error.message,
    });
    ShowError("Something Went Wrong!");
  }
}

function* getLkRecipientDetails({ payload }) {
  try {
    const response = yield call(LkRecipientDetails, payload);
    yield put({ type: LK_RECIPIENT_DETAILS_SUCCESS, response });
  } catch (error) {
    yield put({
      type: LK_RECIPIENT_DETAILS_FAIL,
      message: error?.response?.data?.message,
    });
    ShowError("Something Went Wrong!");
  }
}
function* editLkRecipientDetails({ payload }) {
  try {
    const response = yield call(editLkRecipient, payload);
    yield put({ type: EDIT_LK_RECIPIENT_SUCCESS, response });
    ShowSucess(response?.message ? response?.message : "Updated Successfully", {
      position: "top-right",
    });
  } catch (error) {
    yield put({
      type: EDIT_LK_RECIPIENT_FAIL,
      message: error?.response?.data?.message,
    });
    ShowError("Something Went Wrong!");
  }
}

function* CartSaga() {
  yield takeLatest(LK_RECIPIENT_DETAILS, getLkRecipientDetails);
  yield takeLatest(EDIT_LK_RECIPIENT, editLkRecipientDetails);
  yield takeLatest(LK_RECIPIENT_HISTORY, getLKRecipientHistory);
}

export default CartSaga;
